/* IZ menus (Nov 2026): category rail switching + hover preview tile. Desktop only; mobile drawer untouched. */
(function () {
  'use strict';

  function initRail(wrap) {
    if (wrap.dataset.izInit) return;
    wrap.dataset.izInit = '1';
    var links = wrap.querySelectorAll('.iz-rail__link[data-iz-panel]');
    var panels = wrap.querySelectorAll('.iz-cards[data-iz-panel]');
    var timer = null, current = null;
    var swap = null;
    function show(id) {
      if (current === id) return;
      current = id;
      links.forEach(function (l) {
        var on = l.dataset.izPanel === id;
        l.classList.toggle('is-on', on);
        if (on) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
      });
      var next = wrap.querySelector('.iz-cards[data-iz-panel="' + id + '"]');
      if (!next) return;
      clearTimeout(swap);
      panels.forEach(function (p) { if (p !== next && p.classList.contains('is-on')) p.classList.add('is-fading'); });
      next.classList.remove('is-fading');
      swap = setTimeout(function () {
        panels.forEach(function (p) { if (p !== next) p.classList.remove('is-on', 'is-fading'); });
        next.classList.add('is-on');
      }, 160);
    }
    panels.forEach(function (p) {
      p.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft') return;
        var back = wrap.querySelector('.iz-rail__link.is-on');
        if (back) { e.preventDefault(); back.focus(); }
      });
    });
    links.forEach(function (l) {
      if (l.getAttribute('href') === '#') l.setAttribute('role', 'button');
      l.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(function () { show(l.dataset.izPanel); }, 110);
      });
      l.addEventListener('pointerleave', function () { clearTimeout(timer); });
      l.addEventListener('keydown', function (e) {
        l._ptype = '';
        if (e.key === 'ArrowRight') {
          e.preventDefault(); show(l.dataset.izPanel);
          setTimeout(function () { var c = wrap.querySelector('.iz-cards.is-on a'); if (c) c.focus(); }, 180);
        }
      });
      l.addEventListener('pointerdown', function (e) { l._wasOn = l.classList.contains('is-on'); l._ptype = e.pointerType; });
      l.addEventListener('focus', function () { if (l._ptype === 'touch' || l._ptype === 'pen') return; show(l.dataset.izPanel); });
      l.addEventListener('click', function (e) {
        // touch screens at desktop width: first tap switches the panel, second tap follows the link
        var href = l.getAttribute('href');
        var stage = wrap.querySelector('.iz-cards-stage');
        var hidden = stage && getComputedStyle(stage).display === 'none';
        if (href === '#') { e.preventDefault(); if (!hidden) show(l.dataset.izPanel); return; }
        if (hidden) return;
        if (l._ptype !== 'touch' && l._ptype !== 'pen') return;
        if (!l._wasOn) { e.preventDefault(); show(l.dataset.izPanel); }
      });
    });
    var first = links[0];
    if (first) { current = first.dataset.izPanel; first.setAttribute('aria-current', 'true'); }
  }

  function initPreview(container) {
    if (container.dataset.izPrev) return;
    container.dataset.izPrev = '1';
    var slot = container.querySelector('.iz-preview');
    if (!slot) return;
    var img = slot.querySelector('.iz-preview__img');
    var cap = slot.querySelector('.iz-promo-overlay-title');
    var anchor = slot.closest('a');
    var defTitle = slot.getAttribute('data-iz-default-title') || '';
    var defSrc = img ? img.getAttribute('src') : '';
    var defHref = anchor ? anchor.getAttribute('href') : '';
    var links = container.querySelectorAll('.navigation__tier-3 .navigation__link[data-iz-href]');
    if (!img || !links.length) return;
    var tok = 0;
    function set(src, title, href, isReset) {
      var my = ++tok;
      function apply() {
        if (anchor) anchor.setAttribute('href', href || defHref);
        if (cap) cap.textContent = title;
        slot.classList.toggle('is-previewing', !isReset);
      }
      if (img.getAttribute('src') === src) { apply(); return; }
      var pre = new Image();
      pre.onload = function () { if (my === tok) { img.setAttribute('src', src); apply(); } };
      pre.src = src;
    }
    function reset() { set(defSrc, defTitle, defHref, true); }
    links.forEach(function (l) {
      var on = function () {
        if (l.dataset.izImg) set(l.dataset.izImg, l.dataset.izTitle || '', l.dataset.izHref);
        else reset();
      };
      l.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') on(); });
      l.addEventListener('focus', on);
    });
    container.addEventListener('mouseleave', reset);
    container.addEventListener('focusout', function (e) { if (!container.contains(e.relatedTarget)) reset(); });
  }

  function init() {
    document.querySelectorAll('main-navigation .iz-rail-wrap').forEach(initRail);
    document.querySelectorAll('main-navigation .navigation__tier-2-container').forEach(initPreview);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
